















import { defineComponent, PropType } from '@vue/composition-api';

export default defineComponent({
    props: {
        title: {
            type: String,
            default: '',
        },
        desc: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: '',
        },
        btnMsg: {
            type: String,
            default: '',
        },
        cb: {
            type: Function,
            default: () => {
                return {};
            },
        },
        useSlotTitle: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, context) {},
});
